'use strict'
import api from '@/api/api'
import notify from "@/utils/notify"
import router from "@/router"

export default {
  async getShifts(params = {}) {
    const query = new URLSearchParams()
    if (params.page) query.set('page', params.page)
    if (params.per_page) query.set('per_page', params.per_page)
    if (params.search) query.set('search', params.search)
    if (params.user_id) query.set('user_id', params.user_id)
    if (params.store_id) query.set('store_id', params.store_id)
    if (params.status) query.set('status', params.status)
    if (params.from_date) query.set('from_date', params.from_date)
    if (params.to_date) query.set('to_date', params.to_date)

    const data = {
      method: 'get',
      url: `shifts${query.toString() ? `?${query.toString()}` : ''}`,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
    return []
  },

  async getShift(id) {
    const data = {
      method: 'get',
      url: 'shift/' + id,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },

  async getActiveShift() {
    const data = {
      method: 'get',
      url: 'active-shift',
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
    return null
  },

  async startShift(json) {
    const data = {
      method: 'post',
      url: 'shift/start',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 201) {
      notify.alert.success('Shift started successfully')
      return response.data
    }
  },

  async endShift(id, json) {
    const data = {
      method: 'post',
      url: `shift/${id}/end`,
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Shift ended successfully')
      return response.data
    }
  },

  async getShiftSummary(id) {
    const data = {
      method: 'get',
      url: `shift/${id}/summary`,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },
}
